import React from "react";
import { Tooltip, Typography } from "antd";
import { PROJECT_COLOR } from "config/settings";
import { MdInfo } from "react-icons/md";

interface LabelWithTooltipProps {
  labelTitle: string;
  infoTooltipTitle: string;
  maxWidth?: string;
  iconStyle?: React.CSSProperties;
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  labelTitle,
  infoTooltipTitle,
  maxWidth = undefined,
  iconStyle = {},
}) => {
  return (
    <>
      <Typography.Text ellipsis={{ tooltip: labelTitle }} style={{ maxWidth: maxWidth }}>
        {labelTitle}
      </Typography.Text>
      <Tooltip title={infoTooltipTitle}>
        <MdInfo
          size={15}
          style={{
            marginLeft: 5,
            color: `${PROJECT_COLOR}`,
            ...iconStyle,
          }}
        />
      </Tooltip>
    </>
  );
};

export default LabelWithTooltip;
